import { useFormContext, SubmitHandler, useWatch } from 'react-hook-form';
import StepWaitingTime from '../StepWaitingTime';
import { ActionButtons, Button, Para, Stack } from 'ui-components';
import EditInfoLink from './EditInfoLink';
import CancelButton from '../CancelButton';
import ExistingCustomerHeader from './ExistingCustomerHeader';
import { BookFormValues } from '../..';
import StepContainer from '../../StepContainer';
import { ControlledNameField } from '../../../ControlledNameField';
import { CompleteStoreFragment } from 'drycut-graphql';
import { useBookingContext } from '../../BookingProvider';

type Props = {
  store: CompleteStoreFragment;
  onNext: () => void;
  onPrevious: () => void;
  onCancel: () => void;
};

export function NameStep({ store, onPrevious, onNext, onCancel }: Props): React.ReactElement {
  const { watch, setValue, handleSubmit } = useFormContext<BookFormValues>();
  const { manual } = useBookingContext();

  const onSubmit: SubmitHandler<BookFormValues> = (data) => {
    onNext();
  };

  const existingCustomer = useWatch({ name: 'existingCustomer' });

  return (
    <StepContainer onSubmit={handleSubmit(onSubmit)} store={store}>
      {existingCustomer && (
        <ExistingCustomerHeader
          customerName={watch('name')}
          phoneNumber={watch('phone')}
          onNameClick={() => {
            setValue('existingCustomer', false);
          }}
          onPhoneClick={onPrevious}
        />
      )}

      <StepWaitingTime store={store} />

      {!existingCustomer && (
        <Stack gap={2} className="w-72 self-center">
          <ControlledNameField autoComplete={manual ? 'off' : 'name'} />

          <Para size="sm" className="mt-2">
            Meine Nummer ist nicht{' '}
            <EditInfoLink onClick={onPrevious}>{watch('phone')}</EditInfoLink>
          </Para>
        </Stack>
      )}

      <ActionButtons>
        <Button type="submit">Weiter</Button>
        <CancelButton onCancel={onCancel} />
      </ActionButtons>
    </StepContainer>
  );
}
